import axios from "axios";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CURRENT_PATH } from '../API/settings'
import { resetState } from "../../../store/actions/resetState";

export const useLogout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return useCallback(async (getToken) => {
        try {
            await axios.delete(`${CURRENT_PATH}`, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                }
            });
        } catch {
            // fall through — still reset local state and redirect
        }
        dispatch(resetState());
        navigate('/login', { replace: true });
    }, [navigate, dispatch]);
};
